"use strict";
exports.__esModule = true;
var __1 = require("../..");
var useClasses = __1.makeStyles(function (theme) {
    var _a, _b, _c;
    return __1.createStyles({
        container: {
            position: 'relative'
        },
        hoverContainer: {
            '&:hover': {
                '& >div:last-child': {
                    display: 'flex',
                    alignItems: 'center'
                }
            }
        },
        dragContainer: {
            zIndex: 3
        },
        content: {
            overflow: 'hidden'
        },
        draggableContainer: {
            cursor: 'col-resize',
            display: 'none',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            zIndex: 1
        },
        draggableContainerActive: {
            display: 'flex',
            alignItems: 'center'
        },
        arrowLeft: {
            width: 0,
            height: 0,
            borderTop: "4px solid transparent",
            borderBottom: "4px solid transparent",
            borderRight: "4px solid " + ((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.primary.main)
        },
        arrowRight: {
            width: 0,
            height: 0,
            borderTop: "4px solid transparent",
            borderBottom: "4px solid transparent",
            borderLeft: "4px solid " + ((_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.primary.main)
        },
        bar: {
            width: 2,
            background: (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.primary.main,
            borderRadius: 8,
            height: '100%',
            margin: '0 2px'
        }
    });
});
exports["default"] = useClasses;
//# sourceMappingURL=ResizeTableCellStyles.js.map